import React from 'react';

import { Portal, Container } from '../Portal';
import Presets from '../Presets/index';
import { PORTAL_NAMES } from './constants';

export const ActionPortal = (props) => (
  <Portal portalId={PORTAL_NAMES.ACTION}>{props.children}</Portal>
);

export const BreadcrumbsPortal = (props) => (
  <Portal portalId={PORTAL_NAMES.BREADCRUMBS}>{props.children}</Portal>
);

export const SearchPortal = (props) => {
  throw new Error('Search should be move ScreenToolbar to GridToolbar');
};

export const SmartSearchPortal = ({ children }) => (
  <Portal portalId={PORTAL_NAMES.SMART_SEARCH}>{children}</Portal>
);
export const PresetsPortal = ({ children }) => (
  <Portal portalId={PORTAL_NAMES.PRESETS}>{children}</Portal>
);

export const AllFiltersPortal = ({ children }) => (
  <Portal portalId={PORTAL_NAMES.FILTERS}>{children}</Portal>
);

export const FiltersApplyPortal = ({ children }) => (
  <Portal portalId={PORTAL_NAMES.FILTERS_APPLY}>{children}</Portal>
);

export const ActionsPortal = (props) => {
  return <Portal portalId={PORTAL_NAMES.ACTIONS} {...props} />;
};
export const SearchContainer = (props) => (
  <Container portalId={PORTAL_NAMES.SEARCH} {...props} />
);
export const ActionContainer = (props) => (
  <Container portalId={PORTAL_NAMES.ACTION} {...props} />
);
export const ActionsContainer = (props) => (
  <Container portalId={PORTAL_NAMES.ACTIONS} {...props} />
);
export const SmartSearchContainer = (props) => (
  <Container portalId={PORTAL_NAMES.SMART_SEARCH} {...props} />
);
export const PresetsContainer = (props) => (
  <Container portalId={PORTAL_NAMES.PRESETS} {...props} />
);
export const FiltersContainer = (props) => (
  <Container portalId={PORTAL_NAMES.FILTERS} {...props} />
);
export const FiltersApplyContainer = (props) => (
  <Container portalId={PORTAL_NAMES.FILTERS_APPLY} {...props} />
);
export const BreadcrumbsContainer = (props) => (
  <Container portalId={PORTAL_NAMES.BREADCRUMBS} {...props} />
);
